export const VERSION = _VERSION
export const ENV = _ENV
export const XML = _XML
export const ENV_DEVELOPMENT = ENV['development']||false
export const ENV_FILESYSTEM = ENV.system['file']||false
console.log('VERSION,ENV',VERSION,ENV) // todo: remove log


// WEBPACK FOOTER //
// ./src/js/config.js